export default "__VITE_ASSET__DgsQoKXE__"